import { memo } from 'react';

// Both `desktop:min-h-*` utilities are kept so the resolved height stays identical
// to the original inline markup these fields were extracted from.
export const FIELD_INPUT_CLASS =
  ' min-h-8 p-2.5 min-h-[38px] desktop:min-h-[48px] desktop:p-3 box-border w-full rounded-field border border-merchant-border bg-white desktop:text-[16px] text-sm font-medium leading-4 desktop:leading-5 text-merchant-text-primary outline-none focus:border-merchant-primary';

export const FIELD_INPUT_DISABLED_CLASS =
  ' min-h-8 p-2.5 min-h-[38px] desktop:min-h-[48px] desktop:p-3 box-border w-full cursor-not-allowed rounded-field border border-merchant-border bg-merchant-bg-subtle desktop:text-[16px] text-sm font-medium leading-4.5 desktop:leading-6 text-merchant-text-secondary outline-none';

const FieldInput = memo(({ type = 'text', disabled = false, className = '', ...props }) => {
  const baseClass = disabled ? FIELD_INPUT_DISABLED_CLASS : FIELD_INPUT_CLASS;

  return (
    <input
      type={type}
      disabled={disabled}
      className={className ? `${baseClass} ${className}` : baseClass}
      {...props}
    />
  );
});

FieldInput.displayName = 'FieldInput';

export default FieldInput;
